import React, {useState} from "react";
import {Transfer, Input, Card, Collapse, Button, Row, Col, Popover} from "antd";
import compareStringsWithPoints from "../../../../lib/utils/compareStringWithPoints";

const {Panel} = Collapse;

const styles = {
  transfer: {
    height: "60vh",
  },
  transferList: {
    width: "100%",
    height: "60vh",
  },
  card: {
    height: "60vh",
    overflow: "auto",
  },
  cardBody: {
    padding: "0",
    overflow: "auto",
  },
  input: {
    marginBottom: "9px",
  },
  permissionItem: {
    margin: "16px",
  },
};

function RoleCreatingTab(props) {
  const {
    handleChangeRoleName,
    handleIncludeRoles,
    handleCreateRole,
    targetKeys,
    roles,
    permissions,
  } = props;
  const [isDisabledButton, setIsDisabledButton] = useState(true);

  const mockData = permissions.map((item) => ({
    key: item.id,
    id: item.id,
    alias: item.alias,
    dsc: item.dsc,
  }));

  const renderRoleCard = () => {
    const renderCardTitle = () => (
      <h3>
        Ролей в системе:
        {roles.length}
      </h3>
    );
    return (
      <Card style={styles.card} bodyStyle={styles.cardBody} title={renderCardTitle()}>
        <Collapse expandIconPosition="right" ghost>
          {roles.map((item) => (
            <Panel header={item.alias} key={item.id}>
              {item.includedPermissions
                .sort((a, b) => compareStringsWithPoints(a.alias, b.alias))
                .map((permission) => (
                  <div style={styles.permissionItem} key={permission.id}>
                    <i className="included"/>
                    <div>{permission.alias}</div>
                  </div>
                ))}
            </Panel>
          ))}
        </Collapse>
      </Card>
    );
  };

  const renderTransfer = () => {
    const handleChange = (nextTargetKeys) => {
      handleIncludeRoles(nextTargetKeys);
      setIsDisabledButton(false);
    };

    return (
      <Transfer
        dataSource={mockData}
        titles={["Все привилегии", "Привилегии новой роли"]}
        targetKeys={targetKeys}
        onChange={handleChange}
        showSearch
        filterOption={(inputValue, item) =>
          item.alias.toLowerCase().includes(inputValue.toLowerCase()) || (item?.dsc && item.dsc.toLowerCase().includes(inputValue.toLowerCase()))
        }
        style={styles.transfer}
        listStyle={styles.transferList}
        render={(item) => <Popover content={item.dsc}>{item.alias}</Popover>}
      />
    );
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>{renderRoleCard()}</Col>
        <Col flex={1}>
          <Input
            style={styles.input}
            onChange={(e) => {
              handleChangeRoleName(e.target.value);
              setIsDisabledButton(false);
            }}
            placeholder="Введите название"
          />
          {renderTransfer()}
        </Col>
      </Row>
      <Row className="row_buttons" justify="end">
        <Button
          onClick={() => {
            handleCreateRole();
            setIsDisabledButton(true)
          }}
          type="primary"
          disabled={isDisabledButton}
        >
          Создать роль
        </Button>
      </Row>
    </>
  );
}

export default RoleCreatingTab;
